{
  "customer-register-form": {
    "text": {
      "accept": "Tôi chấp nhận ",
      "agb": "Điều khoản chung",
      "required": "*) Thông tin bắt buộc"
    }
  }
}
